<div class="translated-files" data-testid="translated-files-container">
  <header class="translated-files__header">
    <h3
      class="translated-files__completion"
      data-testid="translated-files-completion-heading"
      aria-live="polite"
    >
      Job {{ completionPercentage() }}% Completed
    </h3>
    <div class="files-sub-header">
      <p
        class="translated-files__counter"
        data-testid="translated-files-counter"
      >
        {{ deliveredFiles() }}/{{ totalFiles() }} Files Translated
      </p>
      <a
        class="translated-files__download-all"
        data-testid="translated-files-download-all"
        [class.translated-files__download-all--disabled]="
          !hasAnyDeliveredFiles() || isDownloadingAll()
        "
        [attr.aria-disabled]="!hasAnyDeliveredFiles() || isDownloadingAll()"
        [tabindex]="hasAnyDeliveredFiles() && !isDownloadingAll() ? 0 : -1"
        role="button"
        (click)="downloadAllFiles()"
        (keydown.enter)="downloadAllFiles()"
      >
        @if (isDownloadingAll()) {
          Downloading...
        } @else {
          Download all translated files
        }
      </a>
    </div>
  </header>

  @if (hasLanguageData()) {
    <mat-accordion multi data-testid="translated-files-accordion">
      @for (lang of languageProgress(); track lang.code) {
        <mat-expansion-panel
          #panel
          [attr.data-testid]="'translated-files-language-' + lang.code"
          hideToggle
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="language-header">
                <span class="language-header__toggle">
                  <svg
                    class="language-header__chevron"
                    [class.language-header__chevron--expanded]="panel.expanded"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                <span class="language-header__name">{{ lang.name }}</span>
                <span
                  class="language-header__count"
                  [attr.data-testid]="
                    'translated-files-language-count-' + lang.code
                  "
                >
                  @if (lang.isComplete) {
                    <svg
                      class="language-header__check"
                      [attr.data-testid]="
                        'translated-files-language-complete-' + lang.code
                      "
                      [attr.aria-label]="lang.name + ' translation complete'"
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="13"
                      viewBox="0 0 17 13"
                      fill="none"
                    >
                      <path
                        d="M5.7 12.025L0 6.325L1.425 4.9L5.7 9.175L14.875 0L16.3 1.425L5.7 12.025Z"
                        fill="#29B72F"
                      />
                    </svg>
                  }
                  {{ lang.deliveredCount }}/{{ lang.totalCount }}
                </span>
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="language-content">
            @if (!s3TargetFilesLoaded()) {
              <p class="language-content__loading">Loading files...</p>
            } @else {
              <div class="language-content__column">
                <h5 class="column-header__title">
                  Basic Format Files ({{ lang.basicFiles.length }})
                </h5>
                @if (lang.basicFiles.length === 0) {
                  <p
                    class="language-content__empty"
                    data-testid="translated-files-basic-empty"
                  >
                    No basic format files.
                  </p>
                } @else {
                  <table class="file-table" aria-label="Basic format files">
                    <thead>
                      <tr>
                        <th class="file-table__header file-table__header--name">
                          <button
                            class="file-table__header-button"
                            data-testid="translated-files-basic-sort"
                            (click)="toggleSort(lang.code, 'name', 'basic')"
                            [attr.aria-label]="
                              'Sort by file name ' +
                              (getSortColumn(lang.code, 'basic') === 'name' &&
                              isSortDescending(lang.code, 'basic')
                                ? 'ascending'
                                : 'descending')
                            "
                          >
                            <span>File Name</span>
                            <svg
                              class="file-table__sort-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M6.80111 10.9342V4.95508L4.65527 7.10091L3.46777 5.93424L7.63444 1.76758L11.8011 5.93424L10.6136 7.10091L8.46777 4.95508V10.9342H6.80111ZM12.6344 18.4342L8.46777 14.2676L9.65527 13.1009L11.8011 15.2467V9.26758H13.4678V15.2467L15.6136 13.1009L16.8011 14.2676L12.6344 18.4342Z"
                                fill="#999999"
                              />
                            </svg>
                          </button>
                        </th>
                        <th class="file-table__header file-table__header--size">
                          <button
                            class="file-table__header-button"
                            (click)="
                              toggleSort(
                                lang.code,
                                'size',
                                'basic',
                                lang.basicFiles
                              )
                            "
                            [disabled]="!hasSortableSize(lang.basicFiles)"
                            [attr.aria-label]="
                              'Sort by file size ' +
                              (getSortColumn(lang.code, 'basic') === 'size' &&
                              isSortDescending(lang.code, 'basic')
                                ? 'ascending'
                                : 'descending')
                            "
                          >
                            <span>Size</span>
                            <svg
                              class="file-table__sort-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M6.80111 10.9342V4.95508L4.65527 7.10091L3.46777 5.93424L7.63444 1.76758L11.8011 5.93424L10.6136 7.10091L8.46777 4.95508V10.9342H6.80111ZM12.6344 18.4342L8.46777 14.2676L9.65527 13.1009L11.8011 15.2467V9.26758H13.4678V15.2467L15.6136 13.1009L16.8011 14.2676L12.6344 18.4342Z"
                                fill="#999999"
                              />
                            </svg>
                          </button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (
                        file of getSortedFiles(
                          lang.basicFiles,
                          lang.code,
                          "basic"
                        );
                        track file.id;
                        let i = $index
                      ) {
                        <tr>
                          <td class="file-table__name-cell">
                            @if (file.isDelivered) {
                              <button
                                class="file-table__download-btn"
                                [attr.data-testid]="
                                  'translated-files-basic-file-' + i
                                "
                                [title]="file.name"
                                (click)="downloadFile(file, lang.code)"
                              >
                                {{ file.name }}
                              </button>
                            } @else {
                              <span
                                class="file-table__name--pending"
                                [attr.data-testid]="
                                  'translated-files-basic-file-pending-' + i
                                "
                                [title]="file.name"
                              >
                                {{ file.name }}
                              </span>
                            }
                          </td>
                          <td class="file-table__size-cell">
                            {{
                              file.isDelivered
                                ? (file.displaySize ?? "--")
                                : "--"
                            }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }
              </div>

              <div
                class="language-content__column language-content__column--dtp"
              >
                <h5 class="column-header__title">
                  Desktop Publishing Files ({{ lang.dtpFiles.length }})
                </h5>
                @if (lang.dtpFiles.length === 0) {
                  <p
                    class="language-content__empty"
                    data-testid="translated-files-dtp-empty"
                  >
                    This job does not contain any complex format files.
                  </p>
                } @else {
                  <table
                    class="file-table"
                    aria-label="Desktop publishing files"
                  >
                    <thead>
                      <tr>
                        <th class="file-table__header file-table__header--name">
                          <button
                            class="file-table__header-button"
                            data-testid="translated-files-dtp-sort"
                            (click)="toggleSort(lang.code, 'name', 'dtp')"
                            [attr.aria-label]="
                              'Sort DTP files by name ' +
                              (getSortColumn(lang.code, 'dtp') === 'name' &&
                              isSortDescending(lang.code, 'dtp')
                                ? 'ascending'
                                : 'descending')
                            "
                          >
                            <span>File Name</span>
                            <svg
                              class="file-table__sort-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M6.80111 10.9342V4.95508L4.65527 7.10091L3.46777 5.93424L7.63444 1.76758L11.8011 5.93424L10.6136 7.10091L8.46777 4.95508V10.9342H6.80111ZM12.6344 18.4342L8.46777 14.2676L9.65527 13.1009L11.8011 15.2467V9.26758H13.4678V15.2467L15.6136 13.1009L16.8011 14.2676L12.6344 18.4342Z"
                                fill="#999999"
                              />
                            </svg>
                          </button>
                        </th>
                        <th class="file-table__header file-table__header--size">
                          <button
                            class="file-table__header-button"
                            (click)="
                              toggleSort(
                                lang.code,
                                'size',
                                'dtp',
                                lang.dtpFiles
                              )
                            "
                            [disabled]="!hasSortableSize(lang.dtpFiles)"
                            [attr.aria-label]="
                              'Sort DTP files by size ' +
                              (getSortColumn(lang.code, 'dtp') === 'size' &&
                              isSortDescending(lang.code, 'dtp')
                                ? 'ascending'
                                : 'descending')
                            "
                          >
                            <span>Size</span>
                            <svg
                              class="file-table__sort-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M6.80111 10.9342V4.95508L4.65527 7.10091L3.46777 5.93424L7.63444 1.76758L11.8011 5.93424L10.6136 7.10091L8.46777 4.95508V10.9342H6.80111ZM12.6344 18.4342L8.46777 14.2676L9.65527 13.1009L11.8011 15.2467V9.26758H13.4678V15.2467L15.6136 13.1009L16.8011 14.2676L12.6344 18.4342Z"
                                fill="#999999"
                              />
                            </svg>
                          </button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (
                        file of getSortedFiles(lang.dtpFiles, lang.code, "dtp");
                        track file.id;
                        let i = $index
                      ) {
                        <tr>
                          <td class="file-table__name-cell">
                            @if (file.isDelivered) {
                              <button
                                class="file-table__download-btn"
                                [title]="file.name"
                                (click)="downloadFile(file, lang.code)"
                              >
                                {{ file.name }}
                              </button>
                            } @else {
                              <span
                                class="file-table__name--pending"
                                [title]="file.name"
                              >
                                {{ file.name }}
                              </span>
                            }
                          </td>
                          <td class="file-table__size-cell">
                            {{
                              file.isDelivered
                                ? (file.displaySize ?? "--")
                                : "--"
                            }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }
              </div>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
